import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, fileUrl } from "../lib/api";
import { useLang } from "../context/LanguageContext";
import { MessageCircle } from "lucide-react";

export default function Matches() {
  const { t } = useLang();
  const [matches, setMatches] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try { const { data } = await api.get("/matches"); setMatches(data); }
      finally { setLoading(false); }
    })();
  }, []);

  return (
    <div className="max-w-6xl mx-auto px-6 md:px-12 py-12 md:py-16" data-testid="matches-page">
      <p className="overline mb-3">{t("matches.kicker")}</p>
      <h1 className="font-serif-display text-4xl md:text-5xl tracking-tight">{t("matches.title")}</h1>

      {loading ? <div className="text-center py-32 text-[#8C857B]">{t("common.loading")}</div> :
       matches.length === 0 ? (
        <div className="text-center py-24 mt-10 border border-dashed border-[#E2DCD0] rounded-2xl text-[#8C857B]" data-testid="matches-empty">
          {t("matches.empty")}
        </div>
      ) : (
        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-10">
          {matches.map((m) => {
            const u = m.user;
            const cover = u.photos?.[0] ? fileUrl(u.photos[0]) : null;
            return (
              <div key={m.interest_id} data-testid={`match-${u.id}`} className="rounded-2xl bg-white border border-[#E2DCD0] overflow-hidden lift-on-hover">
                <Link to={`/profile/${u.id}`} className="block aspect-[4/5] relative bg-[#F2EFE9]">
                  {cover ? <img src={cover} alt="" className="absolute inset-0 w-full h-full object-cover" /> :
                    <div className="absolute inset-0 flex items-center justify-center font-serif-display text-5xl text-[#8C857B]">{u.full_name?.[0]}</div>}
                </Link>
                <div className="p-5">
                  <div className="font-serif-display text-2xl">{u.full_name}</div>
                  <div className="text-xs text-[#8C857B] mt-1">{u.age ? `${u.age} ${t("common.years")}` : ""}{u.city ? ` · ${u.city}` : ""}</div>
                  <Link to={`/chat/${u.id}`} data-testid={`open-chat-${u.id}`}
                    className="mt-4 inline-flex items-center gap-2 rounded-full bg-[#C85A44] hover:bg-[#A84A36] text-white px-5 py-2 text-sm transition">
                    <MessageCircle className="h-4 w-4" strokeWidth={1.5}/> {t("matches.openChat")}
                  </Link>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
